import styles from "./UserAccount.module.css";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import { logOut } from "../../../services/User.service";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { resetUserSelector } from "../../../hooks/store/setters";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { userSelector } from "../../../hooks/store/getters";
import { useState } from 'react';

const UserAccount = () => {
    const history = useHistory(); 
    const resetUser = useAppStore(resetUserSelector);
    const user =  useAppStore(userSelector);
    const [showProfile, setShowProfile] = useState(false);

    const userLogout = async() => {
        logOut();
        resetUser();
        history.push("/login");
    }
    
    const openProfile = () => {
        console.log('user', user)
        setShowProfile(true);
    }

    return (
        <>
            <Dropdown className={styles.userDropdown}>
                <Dropdown.Toggle variant="plain" className={styles.userAccount}>
                    <span>{ user.userName }</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={openProfile}>Profile</Dropdown.Item>
                    <Dropdown.Item href="" onClick={userLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            
            { 
                showProfile && <Modal
                    show={showProfile}
                    onHide={() => setShowProfile(false)}
                    centered
                    contentClassName={styles.userProfileModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>User Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={styles.userInfo}>
                            <label>Name : </label>
                            <span> { user.userName } </span>
                        </div>
                        <div className={styles.userInfo}>
                            <label>Email : </label>
                            <span> { user.email } </span>
                        </div>
                        <div className={styles.userInfo}>
                            <label>Role : </label>
                            <span> { user.userRole || "user" } </span>
                        </div>
                    </Modal.Body>  
                </Modal>
            }
        </>
        
    )
}

export default UserAccount;